import {
  TextInput as Input,
  TextInputProps,
  useMantineTheme,
} from "@mantine/core";
import { forwardRef, memo } from "react";

const TextInput = forwardRef<
  HTMLInputElement,
  TextInputProps & {
    withAsterisk?: boolean;
    label?: string;
    labelColor?: string;
  }
>((props, ref) => {
  const { mt = "md", labelColor, ...rest } = props;

  const theme = useMantineTheme();
  let color = rest.disabled
    ? theme.colors.light[7]
    : theme.colors.secondaryTextColor[4];
  return (
    <Input
      ref={ref}
      mt={mt}
      sx={(theme) => ({
        label: {
          color: rest.value ? labelColor || color : color,
          transform: rest.value ? "translateY(-19px)" : "",
          display: rest.placeholder ? "none" : "initial",
          "&::before": {
            background: rest.disabled
              ? theme.colors.secondary[5]
              : theme.colors.secondary[4],
          },
        },
        ".mantine-Input-input": {
          color: `${color} !important`,
          backgroundColor: `${theme.colors.secondary[4]} !important`,
        },
      })}
      {...rest}
    />
  );
});
export default memo(TextInput);
